<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <AdvancedTaskOptions
      :taskOptions="newTaskParams"
      v-on:taskOptionsChange="handleTaskOptionChange"
    >
      <template v-slot:title>
        <slot name="title">
          <v-icon class="mr-2" color="error">mdi-alert</v-icon>
          Start
          <span class="error--text advanced-warn" v-if="isAdvanced">
            Advanced
          </span>
          Rematch
        </slot>
      </template>
      <template v-slot:actions>
        <v-btn @click="close">Cancel</v-btn>
        <v-btn @click="startRematch">Rematch</v-btn>
      </template>
    </AdvancedTaskOptions>
  </v-dialog>
</template>

<style lang="scss">
.advanced-warn {
  margin: 0 8px;
}
</style>

<script>
import * as _ from 'lodash';

import AdvancedTaskOptions from '../../task-creation-v2/steps/AdvancedTaskOptions.vue';
import { buildTaskContextObject } from '@/components/task-creation-v2/utils';

export default {
  data() {
    return {
      dialog: false,
      newTaskParams: {},
      isAdvanced: false
    };
  },
  components: {
    AdvancedTaskOptions
  },
  methods: {
    open(previousParams = {}, isAdvanced = false) {
      this.dialog = true;
      this.newTaskParams = _.cloneDeep(previousParams);
      this.isAdvanced = isAdvanced;
    },
    close() {
      this.dialog = false;
    },
    handleTaskOptionChange(optionKey, optionValue) {
      this.newTaskParams = { ...this.newTaskParams, [optionKey]: optionValue };
    },
    startRematch() {
      const context = JSON.stringify(
        buildTaskContextObject(this.newTaskParams)
      );
      this.$emit('onAgree', context, this.isAdvanced);
      this.close();
    }
  }
};
</script>
